import { getExerciseTypeVersionAdapter } from './utils';
export default getExerciseTypeVersionAdapter;